import { Fragment, ReactNode } from "react";

interface Props {
	text: string;
	/** Resolves a {{q:id}} reference to the question title; return undefined if unknown. */
	titleOf: (id: string) => string | undefined;
	onNavigate: (id: string) => void;
}

const TOKEN = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\)|\{\{q:[a-z-]+\}\})/g;

export default function Inline({ text, titleOf, onNavigate }: Props) {
	return (
		<>
			{text.split(TOKEN).map((part, i): ReactNode => {
				if (part.startsWith("**")) return <strong key={i}>{part.slice(2, -2)}</strong>;

				const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
				if (link)
					return (
						<a key={i} href={link[2]} target="_blank" rel="noreferrer">
							{link[1]}
						</a>
					);

				const ref = part.match(/^\{\{q:([a-z-]+)\}\}$/);
				if (ref) {
					const title = titleOf(ref[1]);
					if (!title) return <Fragment key={i} />;
					return (
						<a
							key={i}
							href={`#q-${ref[1]}`}
							onClick={(e) => {
								e.preventDefault();
								onNavigate(ref[1]);
							}}
						>
							“{title}”
						</a>
					);
				}
				return <Fragment key={i}>{part}</Fragment>;
			})}
		</>
	);
}
